export default function mergeReadWriteRecipientWellIntoReadOnly(readWriteRecipientWell, readOnlyRecipientArray) {
    if (readWriteRecipientWell && readWriteRecipientWell.recipients) {
        for (var _i = 0, _a = readWriteRecipientWell.recipients; _i < _a.length; _i++) {
            var recipient = _a[_i];
            readOnlyRecipientArray.push({ email: recipient.persona.EmailAddress });
        }
    }
}
//# sourceMappingURL=mergeReadWriteRecipientWellIntoReadOnly.js.map